import { makeListingJourney } from '@vs-shop/engine/listing/makeListingJourney';

import {
  RCPROFI_LISTING_ITEMS_PER_PAGE,
  RCPROFI_LISTING_SYNTAX,
  rcprofiListingVocabulary,
  splitRcprofiListingQuery,
} from './listingConfig';
import { rcprofiListingAtoms } from './listingAtoms';

export const rcprofiListingJourney = makeListingJourney({
  atoms: rcprofiListingAtoms,
  fallbackVocabulary: rcprofiListingVocabulary,
  syntax: RCPROFI_LISTING_SYNTAX,
  itemsPerPage: RCPROFI_LISTING_ITEMS_PER_PAGE,
  splitQuery: splitRcprofiListingQuery,
});
